import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RelayService, RelaySettingsDto} from './relay.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-relay',
    templateUrl: './relay.component.html',
    styleUrls: ['./relay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class RelayComponent implements OnInit {

  public settings: RelaySettingsDto[] = [];

  constructor(
    private relayService: RelayService,
    private notificationService: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.loadList();
  }

  private loadList() {
    this.relayService.getSettings().subscribe({
      next: res => {
        this.settings = res;
      },
      error: err => this.notificationService.error('failed to load data'),
    });
  }

  setValue(setting: RelaySettingsDto, status: boolean, permanent: boolean) {
    this.relayService.setSettings(setting.id, {manualStatus: status, resetManualStatusAtNextSchedule: !permanent}).subscribe({
      next: res => this.loadList(),
      error: err => this.notificationService.error('failed to set data'),
    });
  }
}
